/* eslint-disable */
import React, { useEffect, useState } from 'react';
import Footer from '../components/common/Footer';
import CourseSlider from '../components/core/categoryPage/CourseSlider';
import { useParams } from 'react-router-dom';
import { getCategoryPageDetails } from '../services/operations/courseApi';
import Loading from './Loading';
import CourseCard from '../components/core/categoryPage/CourseCard';
import CommingSoon from './CommingSoon';

const CategoryPage = () => {
    const { categoryName } = useParams();
    const [categoryPageData, setCategoryPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchCategoryPageDetails = async () => {
            setLoading(true);
            try {
                const response = await getCategoryPageDetails(categoryName);
                setCategoryPageData(response);
            } catch (error) {
                console.log('Error while fetching category page details in CategoryPage component', error.message);
            }
            setLoading(false);
        };
        fetchCategoryPageDetails();
    }, [categoryName]);

    if (loading) {
        return (
            <div className='h-screen w-screen'>
                <Loading />
            </div>
        );
    }
    if (!categoryPageData) {
        return (
            <CommingSoon
                text="No Course Found Related To This Category"
            />
        );
    }

    return (
        <div className='mt-14 text-richblack-5'>
            <section className='bg-richblack-800 py-16'>
                <div className='w-11/12 max-w-maxContent mx-auto flex flex-col gap-5'>
                    <div className='text-richblack-300 text-sm'>
                        Home / Category /
                        <span
                            className='text-yellow-50 mx-1 cursor-pointer'>
                            {categoryPageData?.selectedCategory?.name}
                        </span>
                    </div>
                    <p
                        className='text-4xl font-medium'
                    >
                        {categoryPageData?.selectedCategory?.name}
                    </p>
                    <p
                        className='text-richblack-300'
                    >
                        {categoryPageData?.selectedCategory?.description}
                    </p>
                </div>
            </section>
            <section className='w-11/12 max-w-maxContent mx-auto py-6'>
                <div className='mb-10'>
                    <header className='text-[2rem] font-semibold mb-4'>
                        Course To Get You Started
                    </header>
                    <div>
                        <CourseSlider
                            courses={categoryPageData?.differentCategories}
                        />
                    </div>
                </div>
                <div className='mb-10'>
                    <header className='text-[2rem] font-semibold mt-10 mb-4'>
                        Top Course in {categoryPageData?.selectedCategory?.name}
                    </header>
                    <div>
                        <CourseSlider
                            courses={categoryPageData?.selectedCategory?.courses}
                        />
                    </div>
                </div>
                <div>
                    <div>
                        <p className='text-[2rem] font-semibold mt-10'>Frequently Bought</p>
                        <div className='flex items-center justify-center lg:justify-between flex-wrap gap-y-20 my-5'>
                            {
                                categoryPageData?.mostSellingCourses?.map((course) => (
                                    <div
                                        key={course?._id}
                                        className='lg:w-[29rem] xl:w-[35rem] sm:w-[90%] w-full overflow-hidden'
                                    >
                                        <CourseCard course={course} cardHeight='20rem' />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </section>
            <div>
                <Footer />
            </div>
        </div>
    );
};

export default CategoryPage;